import { Divider } from "@mantine/core";
import { FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useAuth } from "../../hooks/auth";

export function Manager() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const cadastros = [
    {
      title: "Unidades e alunos",
      description:
        "Cadastre, edite e exclua unidades e gerencie os alunos de cada unidade.",
      to: "/unidades",
    },
  ];

  const charts = [
    {
      title: "Relação de presenças e faltas",
      description:
        "Representação gráfica de presença de membros por unidade em uma lição.",
      to: "/membrosFaltosos",
    },
    {
      title: "Totalizador de perguntas",
      description:
        "Representação gráfica da resposta de uma determinada pergunta por trimestre.",
      to: "/relacaoPerguntas",
    },
    {
      title: "Percentual de membros presentes",
      description:
        "Representação gráfica do percentual de membros presentes por classe em uma lição.",
      to: "/percentMembers",
    },
    {
      title: "Relatório de atividades missionárias",
      description:
        "Quantos estudaram a lição, participaram de classe bíblica e deram estudo bíblico por classe em um trimestre.",
      to: "/relatorioMissionario",
    },
    {
      title: "Listagem de membros por classe",
      description:
        "Relação de membros de cada classe, pronta para imprimir ou exportar em PDF.",
      to: "/listaMembros",
    },
  ];

  return (
    <>
      <Header>
        <AppTitle>Escola Sabatina</AppTitle>
        <LogoutButton onClick={() => signOut()}>
          <FiLogOut />
          <span>Sair</span>
        </LogoutButton>
      </Header>

      <PageBody>
        <SectionTitle>Cadastros</SectionTitle>
        <Grid>
          {cadastros.map((c, index) => (
            <Card key={index} onClick={() => navigate(c.to)}>
              <CardTitle>{c.title}</CardTitle>
              <Divider my={6} />
              <CardDescription>{c.description}</CardDescription>
            </Card>
          ))}
        </Grid>

        <SectionTitle style={{ marginTop: "3.2rem" }}>
          Relatórios e gráficos
        </SectionTitle>
        <Grid>
          {charts.map((c, index) => (
            <Card key={index} onClick={() => navigate(c.to)}>
              <CardTitle>{c.title}</CardTitle>
              <Divider my={6} />
              <CardDescription>{c.description}</CardDescription>
            </Card>
          ))}
        </Grid>
      </PageBody>
    </>
  );
}

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.6rem 2rem;
  background-color: #3439a5;
  color: #fff;

  @media (min-width: 768px) {
    padding: 1.8rem 3.2rem;
  }
`;

const AppTitle = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  color: #fff;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 2.2rem;
  }
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 0.6rem;
  color: #fff;
  font-size: 1.4rem;
  padding: 0.6rem 1.2rem;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
  }

  svg {
    font-size: 1.8rem;
  }
`;

const PageBody = styled.div`
  padding: 2rem 1.6rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;

  @media (min-width: 768px) {
    padding: 3.2rem;
  }
`;

const SectionTitle = styled.h2`
  font-size: 1.6rem;
  font-weight: 600;
  color: #47474d;
  margin: 0 0 1.6rem 0;

  @media (min-width: 768px) {
    font-size: 1.8rem;
    margin-bottom: 2rem;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.2rem;

  @media (min-width: 600px) {
    grid-template-columns: 1fr 1fr;
    gap: 1.6rem;
  }

  @media (min-width: 1024px) {
    gap: 2rem;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding: 1.6rem;
  border: 1px solid #c0c0c9;
  border-radius: 1.2rem;
  cursor: pointer;
  background: #fff;
  transition: box-shadow 0.2s, transform 0.15s;

  &:hover {
    box-shadow: 0 6px 24px rgba(52, 57, 165, 0.13);
    transform: translateY(-2px);
    border-color: #3439a5;
  }

  @media (min-width: 768px) {
    padding: 2rem;
  }
`;

const CardTitle = styled.label`
  font-size: 1.6rem;
  font-weight: 600;
  color: #3439a5;
  cursor: pointer;

  @media (min-width: 768px) {
    font-size: 1.7rem;
  }
`;

const CardDescription = styled.label`
  font-size: 1.4rem;
  color: #7a7a80;
  cursor: pointer;
  line-height: 1.5;

  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
`;
